import { useGetQSetByIdQuery } from '@exam-management/graphql';
import { ErrorBox, Loading } from '@shared/components';
import type { PropsWithChildren } from '@shared/utils';
import { createContext } from 'react';
import { Outlet } from 'react-router-dom';

import type { QSet } from './types';

interface QSetProviderProps extends PropsWithChildren {
  qSetId: string;
}

interface QSetContextData {
  qSet: QSet;
}

const QSetContext = createContext<QSetContextData | undefined>(undefined);

function QSetProvider(props: Readonly<QSetProviderProps>) {
  const { qSetId, children } = props;

  const {
    data: getQSetResult,
    loading: isLoading,
    error,
  } = useGetQSetByIdQuery({
    variables: {
      input: {
        id: qSetId,
      },
    },
  });

  if (isLoading) {
    return <Loading height='100%' />;
  }

  if (error) {
    return <ErrorBox />;
  }

  const qSetData = getQSetResult?.excGetQSetById.qSet;

  return (
    <QSetContext.Provider
      value={{
        // FIXME: ขอ Assert Type ไว้นะ และลบ Force Navigate to home ออก เพราะการ navigate จะใช้ PermissionRoute and PermissionRouteGuard คุมแทน
        qSet: qSetData as QSet,
      }}
    >
      {children ?? <Outlet />}
    </QSetContext.Provider>
  );
}

export { QSetContext, QSetProvider };
